function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenDialog = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Heading = require("../Heading");
var _Text = require("../Text");
var _Button = require("../Button");
var _ActivityIndicator = require("../ActivityIndicator");
var Icons = _interopRequireWildcard(require("../Icons"));
var _styles = require("./styles");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _utils = require("../../utils");
var _Message = require("../Message");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["Image", "imageWidth", "imageHeight", "title", "text", "primaryActionCallback", "primaryActionLabel", "primaryActionDisabled", "closeCallback", "closeLabel", "isHidden", "animationType", "style", "children", "hideBox", "trackingLabel", "isLoading", "cardStyle"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var FullScreenDialog = exports.FullScreenDialog = (0, _react.memo)(function (_ref) {
  var Image = _ref.Image,
    imageWidth = _ref.imageWidth,
    imageHeight = _ref.imageHeight,
    title = _ref.title,
    text = _ref.text,
    primaryActionCallback = _ref.primaryActionCallback,
    primaryActionLabel = _ref.primaryActionLabel,
    _ref$primaryActionDis = _ref.primaryActionDisabled,
    primaryActionDisabled = _ref$primaryActionDis === void 0 ? false : _ref$primaryActionDis,
    closeCallback = _ref.closeCallback,
    closeLabel = _ref.closeLabel,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? true : _ref$isHidden,
    _ref$animationType = _ref.animationType,
    animationType = _ref$animationType === void 0 ? 'fade' : _ref$animationType,
    style = _ref.style,
    children = _ref.children,
    _ref$hideBox = _ref.hideBox,
    hideBox = _ref$hideBox === void 0 ? false : _ref$hideBox,
    trackingLabel = _ref.trackingLabel,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    cardStyle = _ref.cardStyle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _trackingLabel = (0, _react.useRef)();
  var _hasImage = !!Image;
  var _hasImageWidth = !!imageWidth;
  var _hasImageHeight = !!imageHeight;
  var _hasPrimaryAction = !!primaryActionCallback && !!primaryActionLabel;
  var _hasCloseCallback = !!closeCallback;
  var _hasCloseLabel = !!closeLabel;
  var _useStyles = (0, _styles.useStyles)(_hasCloseCallback),
    styles = _useStyles.styles;
  (0, _react.useEffect)(function () {
    if (!isHidden && trackingLabel && _trackingLabel.current !== trackingLabel) {
      _trackingLabel.current = trackingLabel;
      trackEvent({
        eventName: trackingEvents.showFullScreenDialog,
        props: {
          title: trackingLabel
        }
      });
    }
  }, [isHidden, trackEvent, trackingEvents.showFullScreenDialog, trackingLabel]);
  return (0, _jsxRuntime.jsxs)(_reactNative.Modal, Object.assign({
    style: [styles.container, style],
    statusBarTranslucent: true,
    animationType: animationType,
    visible: !isHidden,
    onRequestClose: closeCallback,
    transparent: false,
    testID: "FullScreenDialog"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Message.MessageContainer, {}), (0, _jsxRuntime.jsx)(_reactNative.ScrollView, {
      contentContainerStyle: styles.background,
      children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: styles.contentContainer,
        children: [isLoading && (0, _jsxRuntime.jsx)(_ActivityIndicator.ActivityIndicator, {}), (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: [styles.content, !hideBox && styles.card, cardStyle, isLoading && {
            display: 'none'
          }],
          accessibilityRole: (0, _utils.WebAccessibilityRole)('dialog'),
          testID: "FullScreenDialogContent",
          children: [_hasImage && (0, _jsxRuntime.jsx)(_reactNative.View, {
            style: [styles.imageContainer, _hasImageWidth && {
              width: imageWidth
            }, _hasImageHeight && {
              height: imageHeight
            }],
            testID: "FullScreenDialogImageContainer",
            children: (0, _jsxRuntime.jsx)(Image, {
              testID: "FullScreenDialogImage",
              style: styles.image
            })
          }), title && (0, _jsxRuntime.jsx)(_Heading.Heading, {
            style: styles.title,
            level: 2,
            children: title
          }), text && (0, _jsxRuntime.jsx)(_Text.Text, {
            containerStyle: styles.textContainer,
            children: text
          }), children, _hasPrimaryAction && (0, _jsxRuntime.jsx)(_Button.Button, {
            label: primaryActionLabel,
            onPress: primaryActionCallback,
            type: _Button.ButtonType.brand,
            state: {
              disabled: primaryActionDisabled
            }
          }), _hasCloseLabel && _hasCloseCallback && (0, _jsxRuntime.jsx)(_Button.Button, {
            type: _Button.ButtonType.link,
            label: closeLabel,
            onPress: closeCallback,
            size: _Button.ButtonSize.small,
            containerStyle: styles.closeButtonContainer
          }), _hasCloseCallback && (0, _jsxRuntime.jsx)(_Button.Button, {
            type: _Button.ButtonType.icon,
            label: t('fullScreenDialog:cancel'),
            onPress: closeCallback,
            icon: Icons.Close,
            hideLabel: true,
            textStyle: styles.closeIcon,
            containerStyle: [styles.closeIconContainer, hideBox && {
              right: 0
            }],
            size: _Button.ButtonSize.small
          })]
        })]
      })
    })]
  }));
});